import { createRoot } from "react-dom/client";
import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom';
import { AppWithRouter } from "./App";
import history from "./history";
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import './assets/css/style.css';
import './assets/scss/style.scss';
import { Provider } from 'react-redux';
import { persistStore, persistReducer } from 'redux-persist';
import { PersistGate } from 'redux-persist/lib/integration/react';
import { store } from "./store";
import Loader from "./Loader";

export const persistor = persistStore(store);

const rootElement = createRoot(document.getElementById("root"));

rootElement.render(
    <Provider store={store}>
        <PersistGate
            persistor={persistor}
            loading={
                <Loader />
            }
        >
            <HistoryRouter history={history}>
                <AppWithRouter />
            </HistoryRouter>
        </PersistGate>
    </Provider>

);
